module.exports = __webpack_public_path__ + "img/3bc77c45deefcf14f1f786fa272b482b.png";